/**
 * Created by tofaelraju on 10/15/17.
 */
import React from 'react';
import Actions from './admin-actions';
import Photo from '../photo-component';
import AdminForm from '../../shared/admin-form';
import UpdateRole from './update-role';

const Profile = (props)=>{
  const {fields,locked, showAlert, showImage, onToggle, handleChange, onCheck, handleSubmit, handleSelect, isLoading, roleDialogOpen, toggleRoleDialog, onPhotoSelect, imagePreviewSrc, updateRole} = props;
  const {name, user_id, user_name, email, phone, address_line_1, address_line_2, postal_code, city, role, admin, super_admin} = fields;
  return (
    <div>

      <div className="row">
        <div className="col-xs-12 col-sm-3 col-md-3 col-lg-3 col-md m-b-15">
          <Photo
            name={name}
            showImage={showImage}
            locked={locked}
            status={fields.status}
            photoUrl={imagePreviewSrc}
          />
          <Actions
            receiveFeedbackEmail={fields.receive_review_email}
            onToggle={onToggle}
            locked={fields.locked}
            showAlert={showAlert}
            toggleRoleDialog={toggleRoleDialog}
          />
          <UpdateRole
            admin={admin}
            onUpdate={updateRole}
            open={roleDialogOpen}
            super_admin={super_admin}
            onCheck={onCheck}
            handleSelect={handleSelect}
            role={role}
            toggleRoleDialog={toggleRoleDialog}
          />
        </div>

        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-md m-b-15">
          <AdminForm
            name={name}
            city={city}
            phone={phone}
            email={email}
            user_id={user_id}
            isLoading={isLoading}
            onPhotoSelect={onPhotoSelect}
            user_name={user_name}
            postal_code={postal_code}
            address_line_1={address_line_1}
            address_line_2={address_line_2}
            handleChange={handleChange}
            handleSubmit={handleSubmit}
          />
        </div>
      </div>

    </div>
  )
}

export default Profile;



// WEBPACK FOOTER //
// ./src/screens/profile/admin/index.js